import type { Dispositif, TypeDemande } from '@/features/domaine/types/opco'
import type { DispositifProforma } from '@/features/domaine/types/opco/Demande/PROFORMA'
import type { NavigateToDemande, ToDispositif, ToDomaine, ToModule } from '@/router/navigateTo/navigateTo.types.ts'

const TypeDemandeToDomaine: Record<TypeDemande, ToDomaine> = {
  Formation: 'formations',
  ReservationFonds: 'drf',
  Remboursement: 'dr',
  SpecifiqueTT: 'tt',
  Proforma: 'dr',
}

export type DemandeToLocationOptions = {
  typeDemande: TypeDemande
  dispositif?: Dispositif | DispositifProforma
  sousDispositif?: string | null
  origine?: 'extranet' | 'sor'
  id?: number | null
  code?: string | null
}

// Todo: INT - A faire évoluer pour gérer tous les types de demandes
export function demandeToLocation(options: DemandeToLocationOptions): Partial<NavigateToDemande> {
  options = {
    origine: 'extranet',
    ...options,
  }

  const domaine = TypeDemandeToDomaine[options.typeDemande]
  const module = ((): ToModule => {
    if (options.origine === 'sor') return 'dossier'
    if (options.typeDemande === 'Proforma') return 'proforma'

    return 'demande'
  })()
  const dispositif = (() => {
    if (domaine === 'dr') return undefined
    return options.dispositif?.toLowerCase() as ToDispositif
  })()
  const sousDispositif = (() => {
    if (domaine === 'dr') return undefined
    return options.sousDispositif
  })()
  const { id, code } = options

  return {
    to: 'detail',
    domaine,
    module,
    dispositif,
    sousDispositif,
    id,
    code,
  } as NavigateToDemande
}
